export type AnalyticsParamValue = string | number;
export type AnalyticsParams = Record<string, AnalyticsParamValue>;

/**
 * Analytics event sink Port. Application code depends on this interface instead
 * of concrete providers such as Firebase Analytics.
 */
export interface AnalyticsSink {
  log(event: string, params?: AnalyticsParams): void;
}

/** No-op sink for disabled analytics, tests, and development surfaces. */
export class NoopAnalyticsSink implements AnalyticsSink {
  log(_event: string, _params?: AnalyticsParams): void {
    /* no-op */
  }
}
